import { DateTime, Duration } from 'luxon';
import { BadRequestError, ConflictError, ForbiddenError, HttpClientError, HttpServerError, NotFoundError, RestRequestError, ServiceUnavailableError, TooManyRequestsError, UnauthorizedError, } from './fetch-error.types';
import { parseRetryAfter } from './header-utils';
import { parseJsonBody } from './json-parse';
import { HttpServerErrorCodes } from './types';
const SERVICE_UNAVAILABLE_STATUS_CODES = new Set([
    HttpServerErrorCodes.BAD_GATEWAY,
    HttpServerErrorCodes.SERVICE_UNAVAILABLE,
    HttpServerErrorCodes.GATEWAY_TIMEOUT,
]);
export const mapResponseToError = async (url, method, traceId, errorResponse, details) => {
    const jsonBody = (await parseJsonBody(errorResponse));
    const errorParams = {
        method,
        url,
        errorBody: jsonBody,
        statusCode: errorResponse.status,
        details: { ...details, traceId },
    };
    if (errorParams.statusCode === 429) {
        const retryAfter = parseRetryAfter(errorResponse.headers.get('Retry-After')) ??
            DateTime.now()
                .plus(Duration.fromObject({ minutes: 5 }))
                .toJSDate();
        return new TooManyRequestsError({
            ...errorParams,
            retryAfter,
            details: {
                ...errorParams.details,
                retryAfter: retryAfter.toISOString(),
            },
        });
    }
    return errorFromParams(errorParams);
};
export const errorFromParams = (errorParams) => {
    if (errorParams.statusCode === 400) {
        if (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any -- Check if we have the prop
        errorParams.errorBody.errors ||
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any -- Check if we have the prop
            errorParams.errorBody.error) {
            return new BadRequestError(errorParams);
        }
        else {
            return new RestRequestError(errorParams);
        }
    }
    if (errorParams.statusCode === 401) {
        return new UnauthorizedError(errorParams);
    }
    if (errorParams.statusCode === 403) {
        return new ForbiddenError(errorParams);
    }
    if (errorParams.statusCode === 404) {
        return new NotFoundError(errorParams);
    }
    if (errorParams.statusCode === 409) {
        return new ConflictError(errorParams);
    }
    if (400 <= errorParams.statusCode && errorParams.statusCode < 500) {
        return new HttpClientError(errorParams);
    }
    if (SERVICE_UNAVAILABLE_STATUS_CODES.has(errorParams.statusCode)) {
        return new ServiceUnavailableError(errorParams);
    }
    return new HttpServerError(errorParams);
};
